import { IMenuItem, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { getRoute, getRouteByComponent, template } from "src/libs/layouts"
import { LayoutIcon } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { FEED_FILTER_ICON_URL, MY_FEED_FILTER_ICON_URL } from "../data/interfaces"
import useFeedRoute from "../hooks/useFeedRoute"
import useMyFeed from "../hooks/useMyFeed"
import { Link } from "react-router-dom"

const FeedFilterWidget = (): JSX.Element => {
    return <FeedFilters />
}
export default FeedFilterWidget

export const FeedFilters = () : JSX.Element => { 
    const {width} = useScreenSize() 
    const isRoute: boolean = useFeedRoute()
    const isMyFeed: boolean = useMyFeed()
    const isScreen = width > WINDOW_WIDTH.TABLET  
     
    const menuHeight =  isScreen ?  template().header?.height || 0 : 75
    const landFeed: IMenuItem | null = getRouteByComponent("LandscapeView")

    return !!landFeed
        ?
        <>   
            <Link
                to={ `${getRoute( landFeed )}/feed` } 
                className={`indicator dble lrg classic p-0 m-0 overflow-hidden ${ isRoute ? "" : " closed"} ${isMyFeed ? "" : "active"}`}    
                title={ __( "Diaries" ) }
            >
                <div className={ `header-menu-element ${ template().header_menu } main-menu-filter-icon ` }>
                    <LayoutIcon
                        src={ FEED_FILTER_ICON_URL }
                        className="header-menu-icon"
                        style={{ width: menuHeight - 30 }}
                    />
                    <span className='header-menu-label px-2 ' >
                        <span className="small">
                            { __( "Diaries" ) }
                        </span>
                    </span>
                </div>  
            </Link> 
            <Link 
                to={ `${getRoute( landFeed )}/my-feed` } 
                className={`indicator dble lrg classic p-0 m-0 overflow-hidden ${ isRoute ? "" : " closed"} ${!isMyFeed ? "" : "active"}`}  
                title={ __( "My Freshness" ) }
            >
                <div className={ `header-menu-element ${ template().header_menu } main-menu-filter-icon ` }>
                    <LayoutIcon
                        src={ MY_FEED_FILTER_ICON_URL }
                        className="header-menu-icon"
                        style={{ width: menuHeight - 30 }}
                    />
                    <span className='header-menu-label px-2 ' >
                        <span className="small">
                            { __( "My Freshness" ) }
                        </span>
                    </span>
                </div>  
            </Link> 
        </> 
        :
        <></>
} 
